import React, { useEffect } from 'react';
const pixelId = '1707630427015805';
type PixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push?: unknown;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const load = () => {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, args);else fbq.queue.push(args);
      }) as PixelFunction;
      fbq.queue = [];
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.push = fbq;
      window.fbq = fbq;
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', pixelId);
      fbq('track', 'PageView');
    };
    // Defer the pixel so it never competes with first paint.
    const idle = (window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
    }).requestIdleCallback;
    if (typeof idle === 'function') idle(load, {
      timeout: 2000
    });else window.setTimeout(load, 1200);
  }, []);
  return <noscript data-id="element-82" data-mp="1dd9xo57fkq1u">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-83" data-mp="1dgxq111536ez" />
    </noscript>;
}